import React from 'react';
import { SimpleDonutChart } from 'components/SimpleDonutChart';
import { getChartDataWithGrouping } from '../utils';

import {
	LegendWrapper,
	Row,
	Color,
	Title,
	ColumnWrapper,
} from './InitiativesSummary.styles';

export const SummaryChart = props => {
	const { data, currencySymbol } = props;
	const dataWithGroupping = getChartDataWithGrouping(data);

	return (
		<React.Fragment>
			<SimpleDonutChart
				data={data}
				currencySymbol={currencySymbol}
				height={96}
				width={96}
				paddingAngle={0}
				hideMenu
			/>
			<ColumnWrapper>
				<LegendWrapper>
					{dataWithGroupping.map(item => (
						<Row key={item.name}>
							<Color color={item.color} />
							<Title>
								<span>{item.name}</span>
								<span>({item.value}%)</span>
							</Title>
						</Row>
					))}
				</LegendWrapper>
			</ColumnWrapper>
		</React.Fragment>
	);
};
